import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import sortBy from 'lodash/sortBy';
import uniqueId from 'lodash/uniqueId';

import BaseFormContainer from '../../common/components/form/BaseFormContainer';

import * as productActions from '../product.actions';
import * as productCategoryActions from '../../product-category/product-category.actions';
import { Localize } from '../../../locale/localization';

import ProductForm from './ProductForm';

const constraints = {
  name: {
    presence: {
      message: `^${Localize('form.product-category.name.error')}`
    },
  },
  description: {
    presence: {
      message: `^${Localize('form.product-category.description.error')}`
    },
  },
  // url: {
  //   url: {
  //     message: `^${Localize('form.product-category.url.error')}`
  //   },
  // },
};

class ProductFormContainer extends BaseFormContainer {
  constructor(props) {
    super(props);

    const formData = {
      name: '',
      description: '',
      descriptions: [],
      url: '',
    };

    this.state = {
      ...this.state,
      formData,
    };
  }

  componentWillMount = () => {
    const {
      id,
      getProducts,
    } = this.props;

    if(id) {
      getProducts().then(() => {
        const { productCategory } = this.props;
        const {
          name = '',
          description = '',
          url = '',
          descriptions = [],
        } = productCategory;

        if(descriptions.length < 3) {
          const l = 3-descriptions.length;
          for(let i=0; i<l; i++) {
            descriptions.push({
              _id: uniqueId('description'),
              title: '',
              description: ''
            });
          }
        }

        this.setState({
          formData: {
            name,
            description,
            url,
            descriptions,
          }
        }, this.validate);
      });
    }
  }

  getConstraints = () => constraints;

  doSubmit = (formData) => {
    const { updateProductCategory, cancelPath, history } = this.props;

    const descriptions = formData.descriptions.filter(description => description.title !== "");

    updateProductCategory({
      _id: this.props.id,
      ...formData,
      descriptions,
    }).then(() => {
      history.replace(cancelPath);
    });
  }

  onDescriptionChange = (event) => {
    const { value, name } = event.target;

    const splitted = name.split('-');

    this.state.formData.descriptions[splitted[1]][splitted[0]] = value;

    const touchedFields = [
      ...this.state.touchedFields.filter((item) => item !== name),
      name,
    ];
    this.setState({
      touchedFields,
    });
    this.validate();
  }

  onCancel = (event) => {
    event.preventDefault();
    
    const { cancelPath, history } = this.props;
    history.replace(cancelPath);
  }

  render() {
    return (
      <ProductForm
        enabled={!this.state.isSubmitting}
        onSubmit={this.onSubmit}
        onCancel={this.onCancel}
        onInputChange={this.onInputChange}
        onBlur={this.onBlur}
        onDescriptionChange={this.onDescriptionChange}
        errors={this.state.errors}
        touchedFields={this.state.touchedFields}
        isValid={this.state.isValid}
        name={this.state.formData.name}
        description={this.state.formData.description}
        descriptions={this.state.formData.descriptions}
        url={this.state.formData.url}
      />
    );
  }
}

const mapStateToProps = (state, { match, cancelPath }) => {
  const {
    id
  } = match.params;

  
  const category = state.entities.productCategory.byId[id];
  const productCategory = category ? {
    ...category,
    descriptions: sortBy(category.descriptions.map(descriptionId => {
      return state.entities.productDescription.byId[descriptionId];
    }), '_id')
  } : null;

  //TODO
  return {
    id,
    productCategory,
    cancelPath,
  };
};

const ConnectedProductFormContainer = connect(
  mapStateToProps,
  Object.assign({}, productActions, productCategoryActions),
)(ProductFormContainer);

export default withRouter(ConnectedProductFormContainer);


// WEBPACK FOOTER //
// ./src/modules/product/components/ProductFormContainer.js